/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-list-select/~/lodash/_freeGlobal.js
 ** module id = 493
 ** module chunks = 0
 **/